import { createFileRoute } from '@tanstack/react-router';
import { FacebookFormsAlias } from '@/pages/workspaces/integrations/forms/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/facebook_lead_ads_/$formId')(
  {
    component: FacebookFormAliasRoute,
  },
);

function FacebookFormAliasRoute() {
  const { workspaceId, formId } = Route.useParams();
  return <FacebookFormsAlias workspaceId={String(workspaceId)} formId={formId} />;
}
